import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { BaseApiService } from './base-api.service';
import { Matter } from '../models/matter';
import { environment } from '../../../environments/environment';
import { PagingOptions } from '../models/paged-options';
import { Activity } from '../models/activity';
import { Message } from '../models/message';
import { ClientDocument } from '../models/client-document';

@Injectable({
  providedIn: 'root',
})
export class MatterService extends BaseApiService<Matter> {
  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/matters`);
  }

  getMatter(matterId: string) {
    return this.httpClient.get<Matter>(this.idApiUrl(matterId));
  }

  getMessages(matterId : string, fromClient: boolean, pagingOptions: PagingOptions) {
    return this.getPagedList<Message>(pagingOptions, this.idApiUrl(matterId) + '/Messages', { fromClient });
  }

  getActivities(matterId : string) {
    return this.httpClient.get<Activity[]>(this.idApiUrl(matterId) + '/Activities');
  }

  getMatters(pagingOptions: PagingOptions, openOnly?: boolean) {
    return this.getPagedList<Matter>(pagingOptions, undefined, { openOnly });
  }

  getClientDocuments(matterId: string) {
    const url = this.idApiUrl(matterId) + '/ClientDocuments';
    return this.httpClient.get<ClientDocument[]>(url);
  }
}
